import { type ReactNode } from 'react';

export function Field(props: {
  label: string;
  hint?: string | undefined;
  labelAddon?: ReactNode | undefined;
  children: ReactNode;
}) {
  return (
    <label className="block text-[13px] font-medium text-slate-700 dark:text-slate-300">
      <span className="inline-flex items-center gap-1.5 tracking-tight">
        {props.label}
        {props.labelAddon}
      </span>
      {props.children}
      {props.hint ? (
        <span className="mt-1.5 block text-xs font-normal leading-relaxed text-slate-500 dark:text-slate-400">
          {props.hint}
        </span>
      ) : null}
    </label>
  );
}
